function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_2_9415)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 30,
  height: 30,
  rx: 15,
  fill: "#5B60DC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 30,
  height: 30,
  rx: 15,
  fill: "url(#paint0_linear_2_9415)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "white",
  strokeOpacity: 0.1
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_9415)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.1638 11.2258H16.1819C16.5661 10.3652 17.3785 9.38905 19.0833 9.33657C20.6578 9.2715 21.1932 10.2203 21.1638 11.2258Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.018 11.2258H15.9999C15.6157 10.3652 14.8032 9.38905 13.0985 9.33657C11.5239 9.2715 10.9886 10.2203 11.018 11.2258Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6131 22.6542V22.6668H14.3674V22.6584L17.6131 22.6542Z",
  fill: "#606060"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8586 17.2122H17.6136V22.6541H21.361C21.495 22.6536 21.6234 22.6001 21.7182 22.5054C21.8129 22.4106 21.8664 22.2823 21.867 22.1483L21.8586 17.2122ZM10.1481 22.1587C10.1481 22.2923 10.2012 22.4205 10.2956 22.515C10.3901 22.6095 10.5183 22.6625 10.6519 22.6625H14.3679V17.2164H10.1397L10.1481 22.1587ZM17.6136 12.2548V16.5476H21.8586V16.5267H22.1672C22.3014 16.5267 22.4301 16.4733 22.5249 16.3785C22.6198 16.2836 22.6731 16.1549 22.6731 16.0208V12.7355C22.673 12.6225 22.6348 12.5128 22.5647 12.4241C22.4946 12.3354 22.3968 12.2728 22.2869 12.2464C22.2478 12.2361 22.2076 12.2312 22.1672 12.2318H17.6241M14.3784 12.2318H9.84786C9.71423 12.2318 9.58606 12.2848 9.49157 12.3793C9.39708 12.4738 9.34399 12.6019 9.34399 12.7355V16.0229C9.3451 16.1565 9.39882 16.2843 9.49353 16.3786C9.58824 16.4729 9.7163 16.5261 9.84996 16.5267H10.1481H14.3763V12.2338",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_2_9415",
  x: 0,
  y: 0,
  width: 34,
  height: 34,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2_9415"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2_9415",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2_9415",
  x1: 41,
  y1: 31,
  x2: 16,
  y2: 10,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70C1FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70C1FC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_9415"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13.3333,
  height: 13.3333,
  fill: "white",
  transform: "translate(9.33337 9.33337)"
})));

function SvgIconPurchaseAuthBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPurchaseAuthBadge);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };